import { render, staticRenderFns } from "./r-item-upgrade-mode.vue?vue&type=template&id=396620bf"
import script from "./r-item-upgrade-mode.vue?vue&type=script&lang=js"
export * from "./r-item-upgrade-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396620bf')) {
      api.createRecord('396620bf', component.options)
    } else {
      api.reload('396620bf', component.options)
    }
    module.hot.accept("./r-item-upgrade-mode.vue?vue&type=template&id=396620bf", function () {
      api.rerender('396620bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/upgrade/r-item-upgrade-mode.vue"
export default component.exports